export const DETAIL_END_USER_PLAN = 'end_user_plan';
export const DETAIL_END_USER_PLAN_WEBSITES = 'end_user_plan_websites';
export const DETAIL_END_USER_PLAN_WEBSITES_PAGES = 'end_user_plan_websites_pages';



export const REGULAR_MAXIMUM_PAGE_CAPACITY = 1_000_000;
